/* eslint-disable no-console */
/* eslint-disable comma-dangle */
/* eslint-disable max-len */

import { ProductItemWidget } from './widgets/productItemWidget';
import _ from 'lodash';

/**
 * Adds or updates url query params
 * @param uri - The url to add, update the query params on.
 * @param key - Query param key.
 * @param value - Value for the query param.
 * @return String created Uri with updated query params.
 */

function updateQueryStringParameter(uri, key, value) {
	const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	const separator = uri.indexOf('?') !== -1 ? '&' : '?';
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + '=' + value + '$2');
	} else {
		return `${uri}${separator}${key}=${value}`;
	}
}

// shorthand for doing a query selector and returning an array, instead of an array-like list
function selAll(sel, el = document.body) {
	if (!el && el === null) {
		console.warn('Utils -> selAll', 'parent element was provided, but was equal to null. Returning empty array.', sel);
		return [];
	}

	el = el || document.body;
	return Array.from(el.querySelectorAll(sel));
}

/**
 * @description Utility for checking JS breakpoints, so they behave the same as CSS media query breakpoints.
 * @param breakName (string) - Possible values are "xs", "sm", "md", "lg".
 * @param isMoreThan (boolean) - whether or not to use ">" logic.
 * @param andIsEqual (boolean) - whether or not to use ">=" or "<=" logic (combines with isMoreThan).
 * @return (boolean) - whether window width fell below or above the specified break point.
 */
function checkBP(breakName, isMoreThan = false, andIsEqual = false) {
	let winWidth = window.innerWidth;

	let logic = function(val) {
		if (isMoreThan) {
			if (andIsEqual) return winWidth >= val;
			return winWidth > val;
		}

		if (andIsEqual) return winWidth <= val;
		return winWidth < val;
	};

	switch (breakName) {
		case 'ms': return logic(320); // ms: mobile-small // only useful if `isMoreThan` or `andIsEqual` is true
		case 'mp': return logic(360); // mp: mobile portrait
		case 'ml': return logic(480); // ml: mobile landscape
		case 'tp': return logic(768); // tp: tablet portrait
		case 'ds': return logic(992); // ds: desktop small
		case 'dm': return logic(1200); // dm: desktop medium
		case 'dl': return logic(1600); // dl: desktop large
	}
}

function isOnMobile() {
	return window.innerWidth < 992;
}

function isSmallerThanTablet() {
	return window.innerWidth < 768;
}

/**
 * @description show/hide LoaderOverlay widget
 * @param doShow (boolean) - true: show widget; false: hide widget
 * @param $scrollToElement (jQuery Element) - optionally pass a jQuery element to scroll to when loading is finished
 */
function showLoaderOverlay(doShow, $scrollToElement) {
	doShow = doShow == null || undefined ? true : doShow;

	let $loaderOverlay = $('.loaderOverlay');

	if (doShow) {
		if ($scrollToElement && $scrollToElement.length) {
			$loaderOverlay.data('data-scroll-to', $scrollToElement.offset().top);
		}

		// made loaderWrap fixed pos so don't need no-scroll
		// $('body').addClass('no-scroll');
		$loaderOverlay.removeClass('d-none');
	} else {
		// made loaderWrap fixed pos so don't need no-scroll
		// $('body').removeClass('no-scroll');
		$loaderOverlay.addClass('d-none');

		// if element is passed in and doShow is false
		if ($scrollToElement && $scrollToElement.length) {
			scrollToEl($scrollToElement);
		} else if ($loaderOverlay.data('data-scroll-to')) { // if 'scroll to' element was passed in at time of opening loader, use it now
			scrollToEl($loaderOverlay.data('data-scroll-to'));
		}

		$loaderOverlay.data('data-scroll-to', null);
	}
}

/**
 * @description Utility for finding sibling of an element. if it doesn't have direct sibling, it will find parent's sibling
 * @param $el (jQuery element) - Element to check
 * @return (jQuery element) - sibling from element
 */
function findSibling($el) {
	// looping until find sibling
	let deepSearch = (el) => {
		let $nextSibling = el.next();
		let $parent = el.parent();

		if (!$nextSibling.length > 0) {
			if ($parent.length > 0) return deepSearch($parent);
			else return $el;
		} else {
			return $nextSibling;
		}
	};

	return deepSearch($el);
}


function isAndroid(ua = null) {
	// stops errors in unit tests, which don't know what `navigator` is
	if (typeof navigator === 'undefined') return false;

	ua = ua || navigator.userAgent;
	let regExp = new RegExp('Android', 'i');
	return !!(ua.match(regExp));
}

function isIE10OrLess() {
	let docMode = document['documentMode'];
	if (!docMode) return false;
	if (docMode <= 10) return true;
}

function isMSEdge(ua = null) {
	// stops errors in unit tests, which don't know what `navigator` is
	if (typeof navigator === 'undefined') return false;

	ua = ua || navigator.userAgent;
	let regExp = new RegExp('Edge', 'i');
	return !!(ua.match(regExp));
}

function isIE11OrLess() {
	let docMode = document['documentMode'];
	if (!docMode) return false;
	if (docMode <= 11) return true;
}

function isIOS(ua = null) {
	// stops errors in unit tests, which don't know what `navigator` is
	if (typeof navigator === 'undefined') return false;

	ua = ua || navigator.userAgent;
	let regExp = new RegExp('iPad|iPhone|iPod', 'i');
	return !!(ua.match(regExp));
}

function isIPad(ua = null) {
	// stops errors in unit tests, which don't know what `navigator` is
	if (typeof navigator === 'undefined') return false;

	ua = ua || navigator.userAgent;
	let regExp = new RegExp('iPad', 'i');
	return !!(ua.match(regExp));
}

function isIPhone(ua = null) {
	// stops errors in unit tests, which don't know what `navigator` is
	if (typeof navigator === 'undefined') return false;

	ua = ua || navigator.userAgent;
	let regExp = new RegExp('iPhone', 'i');
	return !!(ua.match(regExp));
}

function isFirefox() {
	return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

// gets the CSS & JS name of the 'transform' property, which can vary from browser to browser
function getTransformName() {
	let st = window.getComputedStyle(document.body, null);

	let transList = [];

	if (st.getPropertyValue('transform')) {
		transList.push({
			css: 'transform',
			js: 'transform'
		});
	}

	if (st.getPropertyValue('-webkit-transform')) {
		transList.push({
			css: '-webkit-transform',
			js: 'webkitTransform'
		});
	}

	if (st.getPropertyValue('-moz-transform')) {
		transList.push({
			css: '-moz-transform',
			js: 'MozTransform'
		});
	}

	if (st.getPropertyValue('-ms-transform')) {
		transList.push({
			css: '-ms-transform',
			js: 'msTransform'
		});
	}

	if (st.getPropertyValue('-o-transform')) {
		transList.push({
			css: '-o-transform',
			js: 'OTransform'
		});
	}

	if (!transList.length) return null;
	return transList;
}


/**
 * Scrolls to an element
 * @param {HTMLElement|number} ref - html element (or jQuery element) or a scroll position in pixels
 * @param {number} dur - duration of the scroll animation
 */
function scrollToEl(ref, dur = 500, offset = 0) {
	let yPos = 0;
	if (typeof ref === 'number') yPos = ref;
	else if ($(ref).length) yPos = $(ref).offset().top;

	$('html, body').animate({
		scrollTop: yPos - offset
	}, dur);
}


/**
 * Gets the window width without the scroll bar
 * REF: https://stackoverflow.com/questions/8339377/how-to-get-screen-width-without-minus-scrollbar
 */
function getWindowWidth() {
	return $('body').innerWidth();
	//   return document.body.clientWidth;
}

function inIframe() {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}

function isBelowMd() {
	return window.innerWidth < 768;
}

function isElementOutViewport(el) {
	let rect = el[0].getBoundingClientRect();
	return rect.bottom < 0 || rect.right < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight;
}

function initProductItemWidget($parent = $('body')) {
	let $item = $parent.find('[data-wg="ProductItemWidget"]');

	_.forEach($item, (obj, i) => {
		new ProductItemWidget(obj);
	});
}

function checkTheme() {
	let theme = localStorage.getItem('woolMarkTheme');

	if (theme) {
		switchTheme(theme);
	} else {
		switchTheme('');
	}
}

function switchTheme(theme) {
	const THEMES = ['iwp', 'wpc', 'restructured'];
	// in case we are on the styleguide page
	$(`[data-theme]`).removeClass('active');
	$(`[data-theme="${theme}"]`).addClass('active');

	if (theme) {
		$.each(THEMES, (i, thm) => {
			$('body').removeClass('is-' + thm);
		});

		if (theme !== 'woolmark') {
			$('body').addClass('is-' + theme);
		} else {
			$('body').addClass('is-' + 'restructured');
		}
	} else {
		$(`[data-theme="woolmark"]`).addClass('active');
	}
}

function generateRandomId() {
	return Math.floor(100000 + Math.random() * 900000);
}

function getCookie(name) {
	// Split cookie string and get all individual name=value pairs in an array
	var cookieArr = document.cookie.split(";");
	
	// Loop through the array elements
	for(var i = 0; i < cookieArr.length; i++) {
		var cookiePair = cookieArr[i].split("=");
		
		/* Removing whitespace at the beginning of the cookie name
		and compare it with the given string */
		if(name == cookiePair[0].trim()) {
			// Decode the cookie value and return
			return decodeURIComponent(cookiePair[1]);
		}
	}
	
	// Return null if not found
	return null;
}

function getApiDefaultOptions() {
	return {
		headers: {
			Authorization: 'Bearer ' + getCookie("awi_access_token")
		}
	}
}

export default {
	updateQueryStringParameter,
	selAll,
	checkBP,
	showLoaderOverlay,
	findSibling,
	isAndroid,
	isIPhone, isIOS, isIPad,
	getTransformName,
	isIE11OrLess, isIE10OrLess, isMSEdge, isFirefox,
	scrollToEl,
	getWindowWidth,
	inIframe,
	isBelowMd,
	isElementOutViewport,
	isOnMobile,
	initProductItemWidget,
	checkTheme,
	isSmallerThanTablet,
	generateRandomId,
	getApiDefaultOptions
};
